import React from 'react';

export default function FAQ({ activeFAQ, setActiveFAQ }) {
    return (
        <section className="bg-white pt-8 sm:pt-12 pb-16 sm:pb-24 relative">
            <div className="container mx-auto px-4 sm:px-6 lg:px-12 max-w-4xl">
                <div className="text-center mb-10 sm:mb-16 space-y-3 sm:space-y-4">
                    <h3 className="text-blue-600 font-bold tracking-widest text-xs sm:text-sm uppercase">FAQ</h3>
                    <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900">Frequently Asked Question</h2>
                </div>

                <div className="space-y-3 sm:space-y-4">
                    {[
                        {
                            question: "Who is Zenruva for?",
                            answer: "Zenruva is built for founders and leadership teams who want progress without friction. If you are tired of managing multiple vendors, unclear ownership, and slow execution, Zenruva gives you one accountable partner from idea to revenue."
                        },
                        {
                            question: "How is Zenruva different from agencies or freelancers?",
                            answer: "Agencies sell time. Freelancers sell tasks. Zenruva delivers results.You work with a single team responsible for strategy, execution, and delivery. There are no handoffs, no blame shifting, and no confusion about ownership. Everything moves forward under one plan and one timeline."
                        },
                        {
                            question: "How long does it take to build and launch?",
                            answer: "Most Zenruva projects reach launch in weeks, not months. Because design, development, automation, and go-to-market are handled together, delays are removed at the source. You receive weekly progress, clear milestones, and predictable delivery."
                        },
                        {
                            question: "Do you work with early-stage startups or established businesses?",
                            answer: "Zenruva works with both. We partner with early-stage founders who want to launch correctly the first time, and with established businesses that need to remove operational drag and scale with confidence. What matters is clarity of intent and readiness to execute."
                        },
                        {
                            question: "What happens after launch?",
                            answer: "Launch is the beginning, not the conclusion. After release, Zenruva focuses on optimization, automation, conversion improvement, and system scale. We stay engaged to ensure your product continues to perform and grow."
                        }
                    ].map((faq, index) => (
                        <div
                            key={index}
                            className={`border rounded-xl sm:rounded-2xl transition-all duration-300 ${activeFAQ === index ? 'border-blue-500 shadow-md bg-blue-50/10' : 'border-gray-200 hover:border-blue-300'}`}
                        >
                            <button
                                onClick={() => setActiveFAQ(activeFAQ === index ? null : index)}
                                className="w-full flex items-center justify-between p-4 sm:p-6 md:p-8 text-left focus:outline-none"
                            >
                                <span className={`text-base sm:text-lg md:text-xl font-medium pr-4 ${activeFAQ === index ? 'text-blue-900' : 'text-gray-700'}`}>
                                    {faq.question}
                                </span>
                                <span className={`flex-shrink-0 ml-4 w-8 h-8 flex items-center justify-center rounded-full transition-colors ${activeFAQ === index ? 'text-blue-600 bg-blue-100' : 'text-gray-400 bg-gray-100'}`}>
                                    {activeFAQ === index ? (
                                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" /></svg>
                                    ) : (
                                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>
                                    )}
                                </span>
                            </button>
                            <div
                                className={`transition-all duration-300 ease-in-out ${activeFAQ === index ? 'max-h-60 overflow-y-auto opacity-100' : 'max-h-0 overflow-hidden opacity-0'}`}
                            >
                                <div className="p-6 md:p-8 pt-0 text-gray-600 leading-relaxed">
                                    {faq.answer}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
